import { render, staticRenderFns } from "./InvoiceDetailsTable.vue?vue&type=template&id=70472c47&"
import script from "./InvoiceDetailsTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports